import React, { Suspense } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Layout from "layouts";

const Homepage = React.lazy(() => import(/* webpackChunkName: "views-home" */ "views/home"));
const NotFoundPage = React.lazy(() => import(/* webpackChunkName: "views-404" */ "views/404"));

const Router = () => {

  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route exact path="/" element={<Homepage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </Suspense >
  );
};

export default Router;
